import {ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FacetSearchService} from '@app/services/facet-search.service';
import {ConfigService, JsonService} from '@dcp/configurator';
import {Facet, ProductSearchService, RoutingService, SortModel} from '@spartacus/core';
import {LaunchDialogService, SearchCriteria} from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {CustomProductListComponentService} from '../../../services/custom-product-list-component.service';
import {SearchNavigationBarComponent} from '../search-navigation-bar.component';

@Component({
  selector: 'dcp-mobile-search-nav-bar',
  templateUrl: './mobile-search-nav-bar.component.html',
  styleUrls: ['./mobile-search-nav-bar.component.scss']
})

export class MobileSearchNavBarComponent extends SearchNavigationBarComponent implements OnInit, OnDestroy {
  selectedFacet: Facet;
  selectedSortOptions: SortModel[];
  facetList$: Observable<Facet[]>;
  hasActiveValue: (facetName: string, searchResultFacets: Facet[]) => boolean = this.facetSearchService.hasActiveValue;

  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    public facetSearchService: FacetSearchService,
    public launchDialogService: LaunchDialogService,
    protected productSearchService: ProductSearchService,
    protected productListComponentService: CustomProductListComponentService,
    protected cd: ChangeDetectorRef,
    protected jsonService: JsonService,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected routingService: RoutingService,
    protected configService: ConfigService,
  ) {
    super(
      platformId,
      facetSearchService,
      launchDialogService,
      productSearchService,
      productListComponentService,
      cd,
      jsonService,
      router,
      activatedRoute,
      routingService,
      configService);
  }

  @HostListener('document:keydown.escape')
  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    this.launchDialogService.closeDialog('Cross click');
  }

  ngOnInit() {
    super.ngOnInit();
    this.facetList$ = this.launchDialogService.data$.pipe(mergeMap((data: Observable<Facet[]>) => data));
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  showSortingOptions(sortOptions: SortModel[]): void {
    this.selectedSortOptions = sortOptions;
  }


  clearAll(): void {
    const query: string = '';
    this.route({query, currentPage: 0});
  }

  protected route(queryParams: SearchCriteria): void {
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
    });
  }
}
